import {
  ADD_LEGAL_ENTITY,
  DELETE_LEGAL_ENTITY,
  GET_LEGAL_ENTITY_PROFILE,
  GET_LEGAL_ENTITY_LIST,
  HIDE_LEGAL_ENTITY_LIST_LOADER,
  SET_LEGAL_ENTITY_PROFILE,
  SET_LEGAL_ENTITY_LIST,
  SET_ERROR_LEGAL_ENTITY_PROFILE,
  SHOW_LEGAL_ENTITY_LIST_LOADER,
  UPDATE_LEGAL_ENTITY_PROFILE,
  LEGAL_ENTITY_PROFILE_LOADER,
} from "./actionTypes";

export const getLegalEntityList = data => ({
  type: GET_LEGAL_ENTITY_LIST,
  payload: data,
});

export const setLegalEntityList = payload => ({
  type: SET_LEGAL_ENTITY_LIST,
  payload,
});

export const showLegalEntityListLoader = () => ({
  type: SHOW_LEGAL_ENTITY_LIST_LOADER,
});

export const hideLegalEntityListLoader = () => ({
  type: HIDE_LEGAL_ENTITY_LIST_LOADER,
});

export const addLegalEntity = (legal_entity = {}, data = {}) => ({
  type: ADD_LEGAL_ENTITY,
  payload: { legal_entity, data },
});

export const deleteLegalEntity = (id, data = {}) => ({
  type: DELETE_LEGAL_ENTITY,
  payload: { id, data },
});

export const getLegalEntityProfile = id => ({
  type: GET_LEGAL_ENTITY_PROFILE,
  payload: id,
});

export const setLegalEntityProfile = payload => ({
  type: SET_LEGAL_ENTITY_PROFILE,
  payload,
});

export const updateLegalEntityProfile = (
  id,
  legal_entity = {},
  data = {},
  signature
) => ({
  type: UPDATE_LEGAL_ENTITY_PROFILE,
  payload: { id, legal_entity, data, signature },
});

export const setErrorLegalEntityProfile = payload => ({
  type: SET_ERROR_LEGAL_ENTITY_PROFILE,
  payload,
});

export const setLegalEntityProfileLoader = () => ({
  type: LEGAL_ENTITY_PROFILE_LOADER,
});
